<span class="badge badge-pedido-status badge-pedido-status-nao-liberado">
    {{status.nome}}
</span>